import React, { useEffect, useState } from "react";
import Main from "../../common/Main/Main";
import Loadspinner from "../../common/Loadspinner";
import QAnsweredbyMeService from "../../services/QAnsweredbyMeService";
import PropTypes from "prop-types";
import DataCards2 from "../../common/DataCards2/DataCards2";
import { getFromEncLocalStorage } from "../../helpers/Utils/Utils";

function QueAnsByMe(props) {
  const [isLoading, setLoading] = useState(false);
  const [queAnsByMe, setQueAnsByMe] = useState([]);
  const [ismore, setMore] = useState(true);

  useEffect(() => {
    getqueAnsbyMe(1);
  }, []);

  const getqueAnsbyMe = async (page) => {
    let scrollPosition = getFromEncLocalStorage("position");
    setLoading(true);
    let reqBody = {
      limit: 10,
      pageNo: page,
    };
    const res = await QAnsweredbyMeService.queAnsByMe(reqBody);

    if (res) {
      if (res.length < 10) {
        setMore(false);
      }
      let data = [...queAnsByMe, ...res];

      setQueAnsByMe(data);
    }
    if (props.location.state != undefined) {
      window.scrollTo(0, scrollPosition);
    }
    setLoading(false);
  };

  const rerender = (val) => {
    getqueAnsbyMe(val);
  };

  return (
    <Main active={"que_ans_by_me"}>
      <Loadspinner filename="QueAnsByMe.js" isLoading={isLoading} isMiddle="true" />
      <DataCards2
        dataList={queAnsByMe}
        rerenderParentCallback={rerender}
        ismore={ismore}
      />
    </Main>
  );
}

export default QueAnsByMe;

QueAnsByMe.propTypes = {
  location: PropTypes.object,
};
